"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _vars = require("../../../common/styles/vars");

require("../styles/_stage.scss");

function getPrimaryClass(a) {
  var b = a.stageComplete,
      c = a.disabled;
  return c ? "stage--disabled" : b ? "stage--completed" : "stage--future";
}

function Stage(a) {
  var b = a.stageNumber,
      c = a.text,
      d = a.minText,
      e = a.stageComplete,
      f = a.subtitle,
      g = a.hideStageNumbers,
      h = a.icon,
      i = a.containerWidth,
      j = a.maxWidth,
      k = a.onClick,
      l = a.disabled,
      m = getPrimaryClass({
    stageComplete: e,
    disabled: l
  }),
      n = g ? c : "".concat(b, ". ").concat(c),
      o = g ? d : "".concat(b, ". ").concat(d);
  return _react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames["default"])("stage", m, {
      "stage--medium": i < _vars.NUMERIC_MEDIA_SIZES.medium,
      "stage--with-icon": h,
      "stage--clickable": k
    }),
    style: {
      maxWidth: j
    },
    onClick: k,
    onKeyDown: (0, _onEnterPressed["default"])({
      onClick: k
    })
  }, h ? _react["default"].createElement("div", {
    className: "stage__icon-wrapper"
  }, _react["default"].createElement(_Icon["default"], {
    color: "white",
    name: h,
    size: 35
  })) : null, _react["default"].createElement("div", {
    className: "stage__text-container"
  }, i < _vars.NUMERIC_MEDIA_SIZES.medium ? !h && _react["default"].createElement("p", {
    className: "stage__text-container__text"
  }, o) : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("p", {
    className: "stage__text-container__text"
  }, n), f ? _react["default"].createElement("p", {
    className: "stage__text-container__subtitle"
  }, "".concat(f)) : null)));
}

var _default = (0, _react.memo)(Stage);

exports["default"] = _default;